var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rightDrawer)?_c('v-navigation-drawer',{attrs:{"app":"","right":"","clipped":""}},[[_c(_vm.rightDrawer,{tag:"component"})]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }